var _g, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-90 0 32)",
    fill: "#D9D2FE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-90 4 28)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.77 20.5H17.272V18.596H11.28V17.546L17.02 11.12H18.77V17.238H20.38V18.596H18.77V20.5ZM13.366 17.238H17.272V12.884H17.16L13.366 17.126V17.238Z",
    fill: "#523FC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFour);
export default __webpack_public_path__ + "static/media/active-four.343ee92fc3c59417404967abcb67064e.svg";
export { ForwardRef as ReactComponent };